import { render, staticRenderFns } from "./AgendaAttendedCustomers.vue?vue&type=template&id=b2a4d97c&scoped=true"
import script from "./AgendaAttendedCustomers.vue?vue&type=script&lang=js"
export * from "./AgendaAttendedCustomers.vue?vue&type=script&lang=js"
import style0 from "./AgendaAttendedCustomers.vue?vue&type=style&index=0&id=b2a4d97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a4d97c",
  null
  
)

export default component.exports